var React = require('react');

function StatThreeTwo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.80371 15.9727C0.80371 7.68838 7.51944 0.972656 15.8037 0.972656C24.088 0.972656 30.8037 7.68839 30.8037 15.9727L30.8037 137.608H0.803701L0.80371 15.9727Z","fill":"url(#paint0_linear_555_1761)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_555_1761","x1":"15.8037","y1":"0.972656","x2":"15.8037","y2":"137.608","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.15625","stopColor":"#FFFCF3","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#FFFCF3","stopOpacity":"0","key":1})]))]);
}

StatThreeTwo.defaultProps = {"width":"31","height":"138","viewBox":"0 0 31 138","fill":"none"};

module.exports = StatThreeTwo;

StatThreeTwo.default = StatThreeTwo;
